import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import Vue from 'vue';
import Treeselect from '@riophae/vue-treeselect'
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import Routes from "../../routes";

export default class TreeSelect extends Component {

  _instances = {};

  configure() {
    return super.configure();
  }

  initialize() {
    this.elements = $('.is-tree-select');
    this.start();
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    this.App.Events.subscribe('form.refreshed', () => {
      return this.start();
    });
  }

  start() {

    this.elements.each((index, element) => {
      return this.instance($(element));
    });

  }

  instance(element) {

    let parent = this,
        include = element.data('include'),
        accepted = element.data('accepted');

    let vm = new Vue({
      el: `#${element.attr('id')}`,
      components: {
        Treeselect
      },
      data: {
        value:         null,
        options:       null,
        multiple:      false,
        clearable:     true,
        searchable:    true,
        searchNested:  true,
        // disableFuzzyMatching: true,
        flattenSearchResults: true,
        disabled:      false,
        openOnClick:   true,
        openOnFocus:   true,
        clearOnSelect: false,
        closeOnSelect: true,
        defaultExpandLevel: 1,
        showCount:     false,
        isCalled:      false,
      },
      created: function() {
        element.removeClass('is-invisible');
      },
      methods: {
        // You can either use callback or return a Promise.
        async loadOptions({ action/*, callback*/ }) {
          if (action === LOAD_ROOT_OPTIONS) {
            if (!this.isCalled) {

              this.isCalled = true;

              let data = {filters: {}};

              if (typeof include === 'string') {
                data.filters.include = include.split(',');
              }

              if (typeof include === 'string') {
                data.filters.accepted = accepted.split(',');
              }

              return parent.App.API.get(Routes.API.CONTENT.TREE, data).then((response) => {

                if (response.data) {

                  if (typeof response.data.data != 'undefined' && response.data.data.length > 0) {
                    this.options = response.data.data;
                    return this.options;
                  }

                }

                return parent.App.UI.Dialog.alert(
                  parent.App.Language.get('errors.internal_error')
                );

              }).catch((error) => {

                return parent.App.UI.Dialog.alert(
                  parent.App.Language.get('errors.internal_error')
                );

              });

            }
          }
        },
        onValueChanged(value) {
          parent.App.Events.publish('sector_id.change', value);
        }
      }
    });

  }

}